// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReportsStyles_modal__3O1WF","cross":"ReportsStyles_cross__3LzEN"};